import { render, staticRenderFns } from "./TaskParameterConfiguration.vue?vue&type=template&id=4314631d&"
import script from "./TaskParameterConfiguration.vue?vue&type=script&lang=ts&"
export * from "./TaskParameterConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports